module.exports = __webpack_public_path__ + "img/messekarte_de.e7820e87.jpg";